import React from 'react';
import './gallery-toolbar.css';

export function sortGalleryItems(items, order) {
  const direction = order === 'oldest' ? 1 : -1;
  const time = (item) => Date.parse(item.created_at || '') || 0;
  return [...(items || [])].sort((a, b) => direction * (time(a) - time(b) || Number(a.id) - Number(b.id)));
}

export default function GalleryToolbar({ eventName, order, onOrderChange }) {
  return <div className="sg-gallery-toolbar">
    <h1>{eventName}</h1>
    <select aria-label="Sort gallery" value={order} onChange={(event) => onOrderChange(event.target.value)}>
      <option value="latest">Latest first</option>
      <option value="oldest">Oldest first</option>
    </select>
  </div>;
}
